module.exports = __webpack_public_path__ + "img/Grammar_4.1cf043ad.svg";